import script from "./conferencePage.vue?vue&type=script&setup=true&lang=js"
export * from "./conferencePage.vue?vue&type=script&setup=true&lang=js"

import "./conferencePage.vue?vue&type=style&index=0&id=486c8199&scoped=true&lang=css"

import exportComponent from "/Users/hooeni/Workspace/eduwind-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-486c8199"]])

export default __exports__